import React from 'react'
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
} from 'react-router-dom'
import urlJoin from 'url-join'

import { Page } from '../../common/components/sections'
import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import { AboutRouter } from '../../about/components'
import { AccountRouter } from '../../account/components'
import {
  AuthRedirect,
  PermissionRedirect,
} from '../../account/components/sections'
import { BrandCurationTasksRouter } from '../../brand-curation-tasks/components'
import { MenuCurationTasksRouter } from '../../menu-curation-tasks/components'
import { TargetedDbFlashPage } from '../../menu-curation-tasks/components/pages'
import { PriorityTasksRouter } from '../../priority-tasks/components'
import { ReportsRouter } from '../../reports/components'
import { SopsRouter } from '../../sops/components'
import { UsersRouter } from '../../users/components'

const MainRouter = () => (
  <BrowserRouter>
    <Routes>
      <Route
        path={urlJoin(APP_ROUTES.ACCOUNT.fullPath, '/*')}
        element={<AccountRouter />}
      />
      <Route
        element={
          <Page>
            <Outlet />
          </Page>
        }
      >
        <Route
          path={urlJoin(APP_ROUTES.MISC.children.USERS.fullPath, '/*')}
          element={
            <AuthRedirect>
              <UsersRouter />
            </AuthRedirect>
          }
        />
        <Route
          path={urlJoin(APP_ROUTES.MISC.children.SOPS.fullPath, '/*')}
          element={
            <AuthRedirect>
              <SopsRouter />
            </AuthRedirect>
          }
        />
      </Route>

      <Route
        path={urlJoin(APP_ROUTES.MENUS.fullPath, '/*')}
        element={
          <AuthRedirect>
            <MenuCurationTasksRouter />
          </AuthRedirect>
        }
      />

      <Route
        path={urlJoin(APP_ROUTES.BRANDS.fullPath, '/*')}
        element={
          <AuthRedirect>
            <BrandCurationTasksRouter />
          </AuthRedirect>
        }
      />

      <Route
        path={urlJoin(APP_ROUTES.MISC.children.ABOUT.fullPath, '/*')}
        element={
          <AuthRedirect>
            <AboutRouter />
          </AuthRedirect>
        }
      />

      <Route
        path={urlJoin(APP_ROUTES.MISC.children.PRIORITY_TASKS.fullPath, '/*')}
        element={
          <AuthRedirect>
            <PriorityTasksRouter />
          </AuthRedirect>
        }
      />

      <Route
        path={urlJoin(
          APP_ROUTES.MISC.children.TARGETED_DB_FLASH.fullPath,
          '/*',
        )}
        element={
          <AuthRedirect>
            <PermissionRedirect
              permissions={
                PERMISSIONS.MENU_CURATION_TASK.START_TARGETED_DB_FLASH
              }
            >
              <TargetedDbFlashPage />
            </PermissionRedirect>
          </AuthRedirect>
        }
      />

      <Route
        path={urlJoin(
          APP_ROUTES.MISC.children.REPORTS.children.MENU_DATA.fullPath,
          '/*',
        )}
        element={
          <AuthRedirect>
            <ReportsRouter />
          </AuthRedirect>
        }
      />

      <Route
        path={APP_ROUTES.NO_MATCH.path}
        element={<Navigate to={APP_ROUTES.MENUS.fullPath} replace />}
      />
    </Routes>
  </BrowserRouter>
)

export default MainRouter
